export default __webpack_public_path__ + "static/media/Usuário.040f187f.svg";